import type { ForwardedRef } from 'react';
import React from 'react';
import type { OptionProps } from 'react-select';
import { components } from 'react-select';
import type { InvitationUserSelectOptionType } from './InvitationUserSelect';
import BorderedIcon from '../components/BorderedIcon';
import SelectEntityOption from '../components/SelectEntityOption';
import emailIcon from '../icons/non-prefilled/16x16/email.svg';

type InvitationUserSelectOptionProps = OptionProps<
  InvitationUserSelectOptionType,
  true
>;

const InvitationUserSelectOption = (
  props: InvitationUserSelectOptionProps,
  ref: ForwardedRef<HTMLDivElement>,
) => {
  const { data, isDisabled } = props;

  return (
    <components.Option {...props}>
      <SelectEntityOption
        {...props}
        ref={ref}
        icon={<BorderedIcon>{emailIcon}</BorderedIcon>}
        label={data.label}
        disabled={isDisabled}
      />
    </components.Option>
  );
};

export default React.forwardRef<
  HTMLDivElement,
  InvitationUserSelectOptionProps
>(InvitationUserSelectOption);
